import { PaletteMode, SimplePaletteColorOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { ChronosphereColorPalette } from './colors';
import { primaryColor } from './status/primary';

export const primary = (
  mode: PaletteMode,
  opts: GetThemeOptions
): SimplePaletteColorOptions & ChronosphereColorPalette => {
  const color = primaryColor(mode, opts);
  return {
    ...color,
    // Use the high/low contrast versions instead. This is meant to backfill the MUI tokens.
    light: mode === 'light' ? color.lowContrast : color.highContrast,
    dark: mode === 'light' ? color.highContrast : color.lowContrast,
  };
};
